import { render, staticRenderFns } from "./RadioArea.vue?vue&type=template&id=08223cb0&"
import script from "./RadioArea.vue?vue&type=script&lang=ts&"
export * from "./RadioArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports